import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    unreadCount: 0,
    items: [],
    nextCursor: null,
    panelOpen: false,
    status: 'idle',
    transportDown: false,
    pollEpoch: 0,
  },
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    setItems: (state, action) => {
      state.items = action.payload.items;
      state.nextCursor = action.payload.nextCursor;
    },
    refreshItems: (state, action) => {
      const latestItems = action.payload.items;
      const latestItemIds = new Set(latestItems.map((item) => item.id));
      const existingItemIds = new Set(state.items.map((item) => item.id));

      if (latestItems.some((item) => !existingItemIds.has(item.id))) {
        // Reset pagination when new first-page items shift page-number offsets.
        state.items = latestItems;
        state.nextCursor = action.payload.nextCursor;
        return;
      }

      state.items = [...latestItems, ...state.items.filter((item) => !latestItemIds.has(item.id))];
    },
    appendItems: (state, action) => {
      const existingItemIds = new Set(state.items.map((item) => item.id));
      state.items.push(...action.payload.items.filter((item) => !existingItemIds.has(item.id)));
      state.nextCursor = action.payload.nextCursor;
    },
    markItemRead: (state, action) => {
      const item = state.items.find((notification) => notification.id === action.payload);
      if (item && !(item.is_read ?? item.isRead)) {
        item.is_read = true;
        item.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
      state.pollEpoch += 1;
    },
    markAllRead: (state) => {
      state.items.forEach((item) => {
        item.is_read = true;
        item.isRead = true;
      });
      state.unreadCount = 0;
      state.pollEpoch += 1;
    },
    togglePanel: (state) => {
      state.panelOpen = !state.panelOpen;
      if (state.panelOpen && state.items.length === 0) {
        state.status = 'loading';
      }
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setTransportDown: (state, action) => {
      state.transportDown = action.payload;
    },
  },
});

export const {
  setUnreadCount,
  setItems,
  refreshItems,
  appendItems,
  markItemRead,
  markAllRead,
  togglePanel,
  setStatus,
  setTransportDown,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
